import moment from 'moment';

export type ExpirationPreset =
  | '1_day'
  | '1_week'
  | '1_month'
  | '3_months'
  | '1_year'
  | 'custom'
  | 'no_expiration';

export const EXPIRATION_PRESET_OPTIONS = [
  { label: '1 day', value: '1_day' },
  { label: '1 week', value: '1_week' },
  { label: '1 month', value: '1_month' },
  { label: '3 months', value: '3_months' },
  { label: '1 year', value: '1_year' },
  { label: 'Custom', value: 'custom' },
  { label: 'No expiration', value: 'no_expiration' },
] as const;

const PRESET_DURATIONS: Record<
  Exclude<ExpirationPreset, 'custom' | 'no_expiration'>,
  moment.DurationInputArg1
> = {
  '1_day': 1,
  '1_week': 1,
  '1_month': 1,
  '3_months': 3,
  '1_year': 1,
};

const PRESET_UNITS: Record<
  Exclude<ExpirationPreset, 'custom' | 'no_expiration'>,
  moment.unitOfTime.DurationConstructor
> = {
  '1_day': 'day',
  '1_week': 'week',
  '1_month': 'month',
  '3_months': 'month',
  '1_year': 'year',
};

export const calculateEffectiveTo = (
  effectiveFrom: string,
  preset: ExpirationPreset,
  customEffectiveTo = '',
): string => {
  if (preset === 'no_expiration') return '';
  if (preset === 'custom') return customEffectiveTo;
  if (!effectiveFrom) return '';

  const amount = PRESET_DURATIONS[preset];
  const unit = PRESET_UNITS[preset];
  return moment(effectiveFrom).add(amount, unit).format('YYYY-MM-DD');
};

export const inferExpirationPreset = (
  effectiveFrom: string,
  effectiveTo: string,
): { preset: ExpirationPreset; customEffectiveTo: string } => {
  if (!effectiveTo) {
    return { preset: 'no_expiration', customEffectiveTo: '' };
  }

  const presets: ExpirationPreset[] = [
    '1_day',
    '1_week',
    '1_month',
    '3_months',
    '1_year',
  ];

  for (const preset of presets) {
    if (calculateEffectiveTo(effectiveFrom, preset) === effectiveTo) {
      return { preset, customEffectiveTo: '' };
    }
  }

  return { preset: 'custom', customEffectiveTo: effectiveTo };
};
